import Styles from './styles.module.scss';

import logo from '../../../theme/assets/svg/tc_cabinet_logo.svg';


const CabinetLogo = () => {
    return (
        <div className={`${Styles.logoWrap}`}>
            <img src={logo} alt="Time Capsule"/>
        </div>
    );
}
export default CabinetLogo;
